import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import firebaseConfig from './firebaseConfig';
import ProtectedRoute from './ProtectedRoute';
import AdminRoute from './AdminRoute';
import Homepage from './components/Homepage';
import Login from './components/Login';
import SignUp from './components/SignUp';
import Portal from './components/Portal';
import PortalHome from './components/PortalHome';
import Profile from './components/Profile';
import Settings from './components/Settings';
import Social from './components/Social';
import Casino from './components/Casino';
import BlackJack from './components/BlackJack';
import PlinkoGame from './components/PlinkoGame';
import SpinTheWheel from './components/SpinTheWheel';
import SlotMachine from './components/SlotMachine';
import Poker from './components/Poker';
import PokerGame from './components/PokerGame';
import Roulette from './components/Roulette';
import Raffle from './components/Raffle';
import Crypto from './components/Crypto';
import Shop from './components/Shop';
import Crafting from './components/Crafting';
import Trade from './components/Trade';
import Trades from './components/Trades';
import Admin from './components/Admin';
import AdminUsers from './components/AdminUsers';
import AdminStore from './components/AdminStore';
import AdminRaffle from './components/AdminRaffle';
import AdminNotices from './components/AdminNotices';
import Bank from './components/Bank';
import { FireAuthProvider, useFireAuth } from './FireAuthContext';
import './styles/base.css';
import './styles/default.css';
import './styles/colour.css';
import './styles/version2.css';
import './styles/space.css';
import './styles/night.css';

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const captchaKey = process.env.REACT_APP_CAPTCHA_KEY;

initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(captchaKey),
  isTokenAutoRefreshEnabled: true
});

function AppContent() {
  const location = useLocation();
  const { updateUser } = useFireAuth();

  useEffect(() => {
    updateUser();
  }, [location, updateUser]);

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'default';
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  return (
    <div className="app-container">
      <div className="background-image"></div>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/portal" element={<ProtectedRoute />}>
          <Route path="" element={<Portal />}>
            <Route index element={<PortalHome />} />
            <Route path="profile" element={<Profile />} />
            <Route path="settings" element={<Settings />} />
            <Route path="social" element={<Social />} />
            <Route path="casino" element={<Casino />} />
            <Route path="blackjack" element={<BlackJack />} />
            <Route path="plinko" element={<PlinkoGame />} />
            <Route path="spin" element={<SpinTheWheel />} />
            <Route path="slots" element={<SlotMachine />} />
            <Route path="roulette" element={<Roulette />} />
            <Route path="poker" element={<Poker />} />
            <Route path="poker/:gameId" element={<PokerGame />} />
            <Route path="raffle" element={<Raffle />} />
            <Route path="market" element={<Crypto />} />
            <Route path="shop" element={<Shop />} />
            <Route path="craft" element={<Crafting />} />
            <Route path="trade/:tradeId" element={<Trade />} />
            <Route path="trades" element={<Trades />} />
            <Route element={<AdminRoute />}>
              <Route path="admin" element={<Admin />} />
              <Route path="admin/users" element={<AdminUsers />} />
              <Route path="admin/store" element={<AdminStore />} />
              <Route path="admin/raffle" element={<AdminRaffle />} />
              <Route path="admin/notices" element={<AdminNotices />} />
              <Route path="admin/bank" element={<Bank />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <FireAuthProvider>
        <AppContent />
      </FireAuthProvider>
    </Router>
  );
}

export default App;
export { db }
